import React, { useState } from "react";
import { useNavigate } from "react-router-dom"; import UsersList from "../../Modals/usersList";
import {
    Box,
    Tab,
    Tabs,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    IconButton,
    SelectChangeEvent,
    MenuItem,
    Select,
    Button,
} from "@mui/material";
import ReceiptIcon from '@mui/icons-material/Receipt';
import StarIcon from "@mui/icons-material/Star";
import SearchBar from "../../components/SearchBar";
import ViewOptInNotification from "../../Modals/viewOptInNotifications";
;
interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <>{children}</>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}
const ViewCustomer = () => {
    const navigate = useNavigate();
    const [openUserModal, setOpenUserModal] = React.useState(false);
    const [selectedUserIds, setSelectedUserIds] = React.useState<string[]>([]);
    const [city, setCity] = useState("default");

    const handleChangeCity = (event: SelectChangeEvent) => {
        setCity(event.target.value as string);
    };
    const usersList = [
        { id: "1", label: "John Doe", avatar: "/static/images/user_placeholder.png" },
        { id: "2", label: "Jane Smith", avatar: "/static/images/user_placeholder.png" },
        { id: "3", label: "Michael Scott", avatar: "/static/images/user_placeholder.png" },
        { id: "4", label: "Pam Beesly", avatar: "/static/images/user_placeholder.png" },
    ];
    const [open1, setOpen1] = useState(false);
    const handleCloseModal1 = () => {
        setOpen1(false);
    };
    const [valueTabs, setValueTabs] = React.useState(0);
    const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
        setValueTabs(newValue);
    };
    const reviews = [
        {
            id: 1,
            userName: "Alice Johnson",
            email: "alice.johnson@example.com",
            orderId: "#Order_0001",
            rating: 5,
            review:
                "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nemo, animi consectetur adipisicing elit.",
            date: "25 July 2025",
            userImage: "assets/images/profile.png",
        },
        {
            id: 2,
            userName: "Alice Johnson",
            email: "alice.johnson@example.com",
            orderId: "#Order_0002",
            rating: 5,
            review:
                "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nemo, animi consectetur adipisicing elit.",
            date: "25 July 2025",
            userImage: "assets/images/profile.png",
        },
        {
            id: 3,
            userName: "Alice Johnson",
            email: "alice.johnson@example.com",
            orderId: "#Order_0003",
            rating: 5,
            review:
                "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nemo, animi consectetur adipisicing elit.",
            date: "25 July 2025",
            userImage: "assets/images/profile.png",
        },
    ];
    const [orderTab, setOrderTab] = useState(0);

    const tabLabels = [
        "All",
        "Pending",
        "Accepted",
        "Ongoing",
        "Completed",
        "Cancelled",
    ];

    const orderData = [
        {
            orderId: "#Order_1001",
            vendor: "Vendor A",
            driver: "Driver X",
            orderType: "Pickup",
            dateTime: "01 Oct 2025, 10:30 AM",
            amount: "$120",
            paymentMethod: "Credit Card",
            status: "Pending",
        },
        {
            orderId: "#Order_1002",
            vendor: "Vendor B",
            driver: "Driver Y",
            orderType: "Delivery",
            dateTime: "03 Oct 2025, 2:15 PM",
            amount: "$80",
            paymentMethod: "PayPal",
            status: "Accepted",
        },
        {
            orderId: "#Order_1003",
            vendor: "Vendor C",
            driver: "Driver Z",
            orderType: "Pickup",
            dateTime: "05 Oct 2025, 5:45 PM",
            amount: "$150",
            paymentMethod: "Cash",
            status: "Ongoing",
        },
        {
            orderId: "#Order_1004",
            vendor: "Vendor D",
            driver: "Driver W",
            orderType: "Delivery",
            dateTime: "07 Oct 2025, 9:00 AM",
            amount: "$200",
            paymentMethod: "Credit Card",
            status: "Completed",
        },
        {
            orderId: "#Order_1005",
            vendor: "Vendor E",
            driver: "Driver V",
            orderType: "Pickup",
            dateTime: "09 Oct 2025, 11:30 AM",
            amount: "$95",
            paymentMethod: "UPI",
            status: "Cancelled",
        },
    ];

    const [searchTerm, setSearchTerm] = useState("");
    return (
        <>
            <div className="main_title d_flex">
                <div className="left_s">
                    <h1>View Customer</h1>
                    <p>
                        <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
                        <button onClick={() => navigate("/manage-customers")}>
                            Manage Customers
                        </button>{" "}
                        - View Customer
                    </p>
                </div>
                <div className="right_s">
                    <Button className="btn btn_primary" onClick={()=> setOpen1(true)}>Opt-in Notifications</Button>
                </div>
            </div>


            <div className="table_header">
                <div className="left_s">
                    <Box className="custom_tabs1" sx={{ width: "100%" }}>
                        <Tabs
                            value={valueTabs}
                            onChange={handleChangeTabs}
                            aria-label="basic tabs example"
                            className="custom_tabs_links"
                        >
                            <Tab label="View Customer" {...a11yProps(0)} />
                            <Tab label="Order History" {...a11yProps(1)} />
                            <Tab label="Feedback & Rating" {...a11yProps(2)} />

                        </Tabs>
                    </Box>
                </div>
            </div>

            <div className="cards view_page">
                <CustomTabPanel value={valueTabs} index={0}>
                    <div className="gap_p">
                        <div className="vew_img w_100">
                            <h6>Image</h6>
                            <figure>
                                <img src="/static/images/user_placeholder.png" alt="img" />
                            </figure>
                        </div>
                        <div className="w_33">
                            <h6>User Id</h6>
                            <p>#User_001
                            </p>
                        </div>
                        <div className="w_33">
                            <h6>Name</h6>
                            <p>Alice</p>
                        </div>
                        <div className="w_33">
                            <h6>Email</h6>
                            <p>Aliceexample.com</p>
                        </div>
                        <div className="w_33">
                            <h6>Phone Number</h6>
                            <p>9833533838</p>
                        </div>
                        <div className="w_33">
                            <h6>Total Orders</h6>
                            <p>50</p>
                        </div>
                        <div className="w_33">
                            <h6>Cancelled Orders</h6>
                            <p>5</p>
                        </div>
                        <div className="w_33">
                            <h6>Amount Spent</h6>
                            <p>$500</p>
                        </div>
                        <div className="w_33">
                            <h6>Onboard Date</h6>
                            <p>30 July 2025</p>
                        </div>
                    </div>
                    <div className="title_inner">
                        <h2>Address Details</h2>
                    </div>
                    <div className="gap_p">

                        <div className="w_100">
                            <h6>Home</h6>
                            <p>C-127, Phase-8, Industrial Area, Sector 73, Sahibzada Ajit Singh Nagar, Punjab 160071</p>
                        </div>
                        <div className="w_100">
                            <h6>Work</h6>
                            <p>C-127, Phase-8, Industrial Area, Sector 73, Sahibzada Ajit Singh Nagar, Punjab 160071</p>
                        </div>
                    </div>
                    <div className="title_inner">
                        <h2>Bank Details</h2>
                    </div>
                    <div className="gap_p">

                        <div className="w_33">
                            <h6>Account Holder Name
                            </h6>
                            <p>Alice </p>
                        </div>
                        <div className="w_33">
                            <h6>Bank Account Number</h6>
                            <p>218978124</p>
                        </div>
                        <div className="w_33">
                            <h6>Bank Name
                            </h6>
                            <p>PNB</p>
                        </div>
                        <div className="w_33">
                            <h6>Bank Branch Code
                            </h6>
                            <p>6228 </p>
                        </div>
                    </div>

                </CustomTabPanel>
                <CustomTabPanel value={valueTabs} index={1}>
                    <Box className="custom_tabs1">
                        <Tabs
                            value={orderTab}
                            onChange={(e, newValue) => setOrderTab(newValue)}
                            className="custom_tabs_links"
                        >
                            <Tab label="All" {...a11yProps(0)} />
                            <Tab label="Pending" {...a11yProps(1)} />
                            <Tab label="Accepted" {...a11yProps(2)} />
                            <Tab label="Ongoing" {...a11yProps(3)} />
                            <Tab label="Completed" {...a11yProps(4)} />
                            <Tab label="Cancelled" {...a11yProps(5)} />
                        </Tabs>
                    </Box>

                    {[0, 1, 2, 3, 4, 5].map((tabIndex) => (
                        <CustomTabPanel key={tabIndex} value={orderTab} index={tabIndex}>
                            <div className="table_header">
                                <div className="left_s">
                                    <Box className="search_box">
                                        <SearchBar
                                            searchTerm={searchTerm}
                                            setDebouncedSearchTerm={setSearchTerm}
                                            placeholder="Search..."
                                        />
                                    </Box>
                                </div>
                                <div className="right_s"></div>
                            </div>
                            <TableContainer className="table_container">
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Order</TableCell>
                                            <TableCell>Vendor Detail</TableCell>
                                            <TableCell>Driver Detail</TableCell>
                                            <TableCell>Order Type</TableCell>
                                            <TableCell>Order Date/Time</TableCell>
                                            <TableCell>Amount</TableCell>
                                            <TableCell>Payment Method</TableCell>
                                            <TableCell>Status</TableCell>
                                            <TableCell>Action</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {orderData
                                            .filter((order) =>
                                                tabIndex === 0 ? true : order.status === tabLabels[tabIndex]
                                            )
                                            .map((order, index) => (
                                                <TableRow key={index} hover>
                                                    <TableCell>{order.orderId}</TableCell>
                                                    <TableCell>{order.vendor}</TableCell>
                                                    <TableCell>{order.driver}</TableCell>
                                                    <TableCell>{order.orderType}</TableCell>
                                                    <TableCell>{order.dateTime}</TableCell>
                                                    <TableCell>{order.amount}</TableCell>
                                                    <TableCell>{order.paymentMethod}</TableCell>
                                                    <TableCell>
                                                        <div className=" form"> <Select
                                                            id="city"
                                                            fullWidth
                                                            value={city}
                                                            onChange={handleChangeCity}
                                                        >
                                                            <MenuItem disabled value="default">Pending</MenuItem>
                                                            <MenuItem value="mumbai">Accept</MenuItem>
                                                            <MenuItem value="pune">Reject</MenuItem>
                                                            <MenuItem value="ahmedabad">Complete</MenuItem>
                                                        </Select></div></TableCell>
                                                    <TableCell>
                                                        <div className="table_actions v2">
                                                            <Box>
                                                                <IconButton onClick={() => navigate("/manage-customers/view-customer")}>
                                                                    <img src="/static/images/eye_icon.svg" alt="View" />
                                                                </IconButton>
                                                            </Box>
                                                            <Box>
                                                                <IconButton>
                                                                    <ReceiptIcon />
                                                                </IconButton>
                                                            </Box>



                                                        </div>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </CustomTabPanel>
                    ))}
                </CustomTabPanel>

                <CustomTabPanel value={valueTabs} index={2}>

                    <div className="table_header">
                        <div className="left_s">
                            <Box className="search_box">
                                <SearchBar
                                    searchTerm={searchTerm}
                                    setDebouncedSearchTerm={setSearchTerm}
                                    placeholder="Search..."
                                />
                            </Box>
                        </div>
                        <div className="right_s"></div>
                    </div>
                    <TableContainer className="table_container">
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Sr. No</TableCell>

                                    <TableCell>Order ID</TableCell>
                                    <TableCell>Rating</TableCell>
                                    <TableCell>Review</TableCell>
                                    <TableCell>Date</TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {reviews.map((item, index) => (
                                    <TableRow key={index} hover>
                                        <TableCell>{item.id}</TableCell>

                                        <TableCell>
                                            <strong>{item.orderId}</strong>
                                        </TableCell>
                                        <TableCell>
                                            <Box display="flex" alignItems="center" gap={0.5}>
                                                <Typography>{item.rating}</Typography>
                                                <StarIcon sx={{ color: "#fbc02d", fontSize: 18 }} />
                                            </Box>
                                        </TableCell>
                                        <TableCell className="max_c2">
                                            <p

                                            >
                                                {item.review}
                                            </p>
                                        </TableCell>
                                        <TableCell>{item.date}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </CustomTabPanel>
            </div>
            <UsersList
                open={openUserModal}
                onClose={() => setOpenUserModal(false)}
                setOpen={setOpenUserModal}
                userIds={selectedUserIds}
                usersList={usersList}
            />
            <ViewOptInNotification open={open1} onClose={handleCloseModal1} setOpen={setOpen1} />
        </>
    );
};

export default ViewCustomer;
